import { useAuth } from "@/auth";
import { CompletionEmailForm } from "@/components/campaign/setup/delivery/CompletionEmailForm";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/delivery/configure",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Vælg modtager",
    },
  },
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const [state] = context.useNewCampaignState();
  switch (state.delivery?.type) {
    case "Excel":
      return <ExcelRouteComponent />;
    default:
      return null;
  }
}

function ExcelRouteComponent() {
  const context = Route.useRouteContext();
  const stepper = context.useStepper();

  const { user } = useAuth();

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  context.stepper.useStepperSubmit(submitHandler);

  return (
    <CompletionEmailForm
      defaultValues={{
        completionEmail:
          stepper.context.delivery?.completionEmail || user.email,
      }}
      updateValues={(values) => {
        stepper.setContext((prev) =>
          prev.delivery?.type === "Excel"
            ? {
                ...prev,
                delivery: {
                  ...prev.delivery,
                  completionEmail: values.completionEmail,
                },
              }
            : prev,
        );
        stepper.goNext();
      }}
      setSubmitHandler={setSubmitHandler}
    />
  );
}
